import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BaseSolarisCard } from '../../Utils/StyleUtils';
import styled from 'styled-components';
export default function OrganisationSwitcherResults(props) {
    const orgs = props.organisations.orgs;
    if (orgs.length === 0) {
        return _jsx(NoOrgsFoundText, { children: "No organisations found" });
    }
    return (_jsx(_Fragment, { children: orgs.map((org) => (_jsx(OrgCard, { "$loading": false, onClick: () => props.openOrg(org.id), children: _jsx("p", { children: org.name }) }, org.id))) }));
}
const OrgCard = styled(BaseSolarisCard) `
	cursor: pointer;
	width: 100%;

	:hover {
		background-color: ${(props) => props.theme.palette.shade5};
	}
`;
const NoOrgsFoundText = styled.p `
	font-size: ${(props) => props.theme.spacing.lg};
	text-align: center;
	/* Make this a whole row in a grid*/
	grid-column: 1 / -1;
`;
//# sourceMappingURL=OrganisationSwitcherResults.js.map